// Make slider initialization a reusable function
function initFeaturedSlider(slider) {
  const container = slider.parentElement;
  const header = container.closest(
    ".featured-slider-container"
  )?.previousElementSibling;
  const prevBtn = header?.querySelector(".prev");
  const nextBtn = header?.querySelector(".next");
  const items = slider.querySelectorAll(".product-card-item");

  if (!items.length) return;

  // Helper functions
  const getCurrentGap = () =>
    parseInt(window.getComputedStyle(slider).gap) || 10;
  const getCardWidth = () => items[0].offsetWidth + getCurrentGap();

  // Slider state
  let currentPosition = 0;
  let maxPosition = slider.scrollWidth - container.offsetWidth;
  let isDragging = false;
  let startX = 0;
  let startPosition = 0;
  const clickThreshold = 5;

  // Initialize
  updateButtons();

  // 1. PREVENT IMAGE DRAGGING
  slider.querySelectorAll("img").forEach((img) => {
    img.setAttribute("draggable", "false");
    img.addEventListener("dragstart", (e) => {
      e.preventDefault();
      return false;
    });
  });

  // 2. NAVIGATION BUTTONS
  if (prevBtn && nextBtn) {
    prevBtn.addEventListener("click", () => {
      currentPosition = Math.min(currentPosition + getCardWidth(), 0);
      slideTo(currentPosition);
    });

    nextBtn.addEventListener("click", () => {
      currentPosition = Math.max(
        currentPosition - getCardWidth(),
        -maxPosition
      );
      slideTo(currentPosition);
    });
  }

  // 3. DRAG HANDLING - MOUSE AND TOUCH
  slider.addEventListener("mousedown", startDrag);
  slider.addEventListener("touchstart", startDrag, { passive: false });

  function startDrag(e) {
    if (e.type === "mousedown" && e.button !== 0) return;

    isDragging = false;
    startX = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    startPosition = currentPosition;

    document.addEventListener("mousemove", handleDrag);
    document.addEventListener("touchmove", handleDrag, { passive: false });
    document.addEventListener("mouseup", endDrag);
    document.addEventListener("touchend", endDrag);

    target = e.target;
    const isInteractiveElement =
      target.closest("select") ||
      target.closest(".card-product__color-option") ||
      target.closest(".quick-card__quick-add");

    if (!isInteractiveElement) {
      e.preventDefault();
    }
  }

  function handleDrag(e) {
    const currentX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
    const diff = startX - currentX;

    if (!isDragging && Math.abs(diff) < clickThreshold) return;

    if (!isDragging) {
      isDragging = true;
      slider.classList.add("dragging");
      document.body.classList.add("slider-dragging");
      slider.style.transition = "none";
    }

    currentPosition = Math.max(Math.min(startPosition - diff, 0), -maxPosition);
    slider.style.transform = `translateX(${currentPosition}px)`;

    e.preventDefault();
  }

  function endDrag(e) {
    document.removeEventListener("mousemove", handleDrag);
    document.removeEventListener("touchmove", handleDrag);
    document.removeEventListener("mouseup", endDrag);
    document.removeEventListener("touchend", endDrag);

    document.body.classList.remove("slider-dragging");

    if (!isDragging) {
      const target = e.target.closest("a");
      if (target) target.click();
      return;
    }

    isDragging = false;
    slider.classList.remove("dragging");

    const cardIndex = Math.round(Math.abs(currentPosition) / getCardWidth());
    currentPosition = -Math.min(cardIndex * getCardWidth(), maxPosition);
    slideTo(currentPosition);
  }

  function slideTo(position) {
    currentPosition = position;
    slider.style.transition = "transform 0.3s ease";
    slider.style.transform = `translateX(${position}px)`;
    updateButtons();
  }

  function updateButtons() {
    if (!prevBtn || !nextBtn) return;
    prevBtn.disabled = currentPosition >= 0;
    nextBtn.disabled = currentPosition <= -maxPosition || maxPosition <= 0;
  }

  // Handle responsive changes
  const resizeObserver = new ResizeObserver(() => {
    maxPosition = slider.scrollWidth - container.offsetWidth;
    currentPosition = Math.max(Math.min(currentPosition, 0), -maxPosition);
    slideTo(currentPosition);
    updateButtons();
  });
  resizeObserver.observe(container);
}

// Initialize all sliders on page load
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".featured-slider").forEach(initFeaturedSlider);
});

// Make the function available globally for reinitialization
window.initFeaturedSlider = initFeaturedSlider;
